<!--
    描述：
    时间：2021-06-22
    Created by 王帅
-->
<template>
	<div class="h100">
		<div class="w-page-main">
			<div class="w-page-header superiors-search-area">
				<div class="left-text overflow-hidden">
					<span><b>菜单列表</b></span>
				</div>
				<div class="btnGroups">
					<el-button type="success"
							   size="small"
							   icon="el-icon-check"
							   v-if="roleBtns.includes('group_role_menu_save') && showBtn"
							   @click="saveClick('roleMenu')">保存
					</el-button>
				</div>
			</div>
			<div class="w-page-container pdb10">
				<div class="w-table-layout">
					<div class="w-table-content"
						 ref="menusContent"
						 style="overflow-y: auto; border: 1px solid #eee">
						<el-tree ref="menusTree"
								 :height="menusTreeData.tableH"
								 :data="menusTreeData.tableData"
								 :props="defaultProps"
								 :expand-on-click-node="false"
								 :highlight-current="true"
								 default-expand-all
								 show-checkbox
								 :check-strictly="true"
								 node-key="id"
								 :default-checked-keys="treeDefaultCheckedKey"
								 @node-click="nodeClick"></el-tree>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapState } from 'vuex'
import { selectTree } from 'api/system/menu.js'
import {
	getRoleMenuByRoleId,
	saveOrUpdateRoleMenu,
	getLimitMenu,
	getRoleMenuRange,
	saveOrUpdateBtns,
} from 'api/system/role.js'
export default {
	name: '',
	props: {
		// 当前是 公共角色 还是 私有角色
		currentRole: {
			type: String,
			default: '',
		},
	},
	data() {
		return {
			//角色id
			roleId: '',
			//树默认选中信息
			treeDefaultCheckedKey: [],
			btnLoading: false,
			//限制的菜单id信息
			limitMenuIdList: [],
			menusTreeData: {
				loading: false,
				tableH: 200,
				tableData: [],

				tableOriData: [],
				tableByRoleData: [],
			},
			defaultProps: {
				children: 'children',
				label: 'sname',
			},
		}
	},
	created() {
		//获取菜单信息
		this.getMenuTreeTableData()
	},
	methods: {
		// 获取全部菜单信息
		getMenuTreeTableData() {
			let that = this
			selectTree({ isSys: 1 }).then((res) => {
				if (res.operationCode == 1) {
					that.menusTreeData.tableOriData = res.data
					that.menusTreeData.tableData =
						that.menusTreeData.tableOriData.concat()
				}
			})
		},

		// 左侧角色点击事件 --- 根据角色ID 获取菜单信息
		getMenuTreeInfoPlus(obj) {
			this.getRoleMenuRange(obj)
		},

		// 根据角色ID 返回能选择的 和 已选择的菜单
		getRoleMenuRange(obj) {
			this.roleId = obj.roleId
			this.treeDefaultCheckedKey = []

			getRoleMenuRange({
				roleId: obj.roleId,
				isSys: '1',
				limitId: obj.limitId,
			}).then((res) => {
				// 能选数组
				this.getLimitMenus(res.data.limitMenuIds, obj.limitId)

				// 赋值选中菜单
				this.treeDefaultCheckedKey = res.data.roleMenuIds

				if (this.treeDefaultCheckedKey.length > 0) {
					let _item = this.$utils.findTree(
						this.menusTreeData.tableData,
						(x) => x.id === this.treeDefaultCheckedKey[0]
					)
					setTimeout(() => {
						_item ? this.nodeClick(_item.item) : ''
						this.$refs.menusTree.setCurrentKey(
							this.treeDefaultCheckedKey[0]
						)
					}, 200)
				}
			})
		},

		// 根据角色id，获取已选择的菜单信息
		getMenuTreeInfoByRoleId(obj) {
			let that = this
			// that.menusTreeData.tableData = that.menusTreeData.tableOriData.concat();
			that.roleId = obj.id
			that.treeDefaultCheckedKey = []
			let param = { roleId: obj.id }
			getRoleMenuByRoleId(param).then((res) => {
				if (res.operationCode == 1) {
					that.treeDefaultCheckedKey = res.data

					if (this.treeDefaultCheckedKey.length > 0) {
						let _item = this.menusTreeData.tableData.find(
							(x) => x.id === this.treeDefaultCheckedKey[0]
						)
						setTimeout(() => {
							_item ? this.nodeClick(_item) : ''
							this.$refs.menusTree.setCurrentKey(
								this.treeDefaultCheckedKey[0]
							)
						}, 200)
					}
				}
			})
		},

		// 根据角色id，获取当前主体能选择的全部菜单信息
		getLimitMenus(arr, limitId) {
			this.limitMenuIdList = []
			this.limitMenuIdList = arr
			let that = this

			if (this.limitMenuIdList.filter((id) => id == -1).length > 0) return
			if (!limitId || limitId === '' || limitId === null) {
				that.menusTreeData.tableData =
					that.menusTreeData.tableOriData.concat()
				return
			}
			let menuTreeArray = that.$utils.toTreeArray(
				this.menusTreeData.tableData
			)
			menuTreeArray = menuTreeArray.map((prop) => {
				let disabled =
					typeof that.limitMenuIdList.find((menuId) => {
						return menuId == prop.id
					}) != 'undefined'
						? false
						: true
				return { ...prop, disabled: disabled }
			})
			that.menusTreeData.tableData = that.$utils
				.toArrayTree(menuTreeArray)
				.concat()
		},

		//保存
		saveClick() {
			let that = this
			if (that.roleId == '') {
				that.$message({ message: '请选择角色信息', type: 'warning' })
				return
			}

			let menuIdsSelection = []
			let checkSelection = this.$refs.menusTree.getCheckedKeys().concat()
			let param = {
				groupId: this.groupId,
				roleId: that.roleId,
				menuIdsSelection: checkSelection,
			}
			saveOrUpdateBtns(param).then((res) => {
				if (res.operationCode == 1) {
					that.$message({ message: '保存成功', type: 'success' })
				}
			})
		},
		//节点点击
		nodeClick(obj) {
			this.$emit('row-click', obj)
		},
	},
	computed: {
		...mapState('app', { clientSize: (state) => state.clientSize }),
		...mapState('menu', {
			roleBtns: (state) => state.roleBtns,
		}),
		...mapState('user', {
			userInfo: (state) => state.userInfo,
		}),

		// 是否展示 btn
		showBtn() {
			let a = this.userInfo.roleType === 1
			let b = this.currentRole === '1007002'
			return a || b
		},
	},
	watch: {
		clientSize(val) {
			this.menusTreeData.tableH = this.$refs.menusContent.offsetHeight
		},
	},
}
</script>

<style scoped lang="less"></style>
